import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    if($(window).width() < 768) {
        document.arrive('.grid-cell', {existing: true}, function () {
            let $cell = $(this);
            let $opener = $cell.find('.srg-modal-opener');
            let $modal_id = $opener.attr('data-srg-modal');
            let $modal = $('#'+$modal_id);
            $cell.click(function(){
                $modal.show();
            });
            $modal.find('.srg-btn-close').click(function(){
                $modal.hide();
            });
        });
    } else {
        document.arrive('.srg-modal-opener', {existing: true}, function () {
            let $opener = $(this);
            let $modal_id = $opener.attr('data-srg-modal');
            let $modal = $('#'+$modal_id);
            $opener.click(function(){
                $modal.show();
            });
            $modal.find('.srg-btn-close').click(function(){
                $modal.hide();
            });
        });
    }
});

